import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AppSpinner } from './appSpinner.model';
import { SpinnerComponent } from './spinner.component';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private spinners = new Array<NgbModalRef>();

  constructor(private modalService: NgbModal) {
  }

  startSpinner(text?: string): number {
    const spinner: AppSpinner = {
      start: true,
      text
    };
    const modalRef = this.modalService.open(SpinnerComponent, { centered: true, backdrop: 'static', keyboard: false });

    modalRef.componentInstance.spinner = spinner;

    this.spinners.push(modalRef);
    return this.spinners.length - 1;
  }

  stopSpinner(index?: number): void {
    if (!index) {
      index = this.spinners.length - 1;
    }
    const ref: NgbModalRef = this.spinners[this.spinners.length - 1];
    if (ref) {
      ref.close();
      this.spinners.splice(this.spinners.length - 1, 1);
    }
  }

}
